"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectInsightByRef = exports.selectInsightsMap = exports.selectInsightRefs = exports.selectInsights = void 0;
// (C) 2021-2022 GoodData Corporation
var insightsEntityAdapter_1 = require("./insightsEntityAdapter");
var toolkit_1 = require("@reduxjs/toolkit");
var sdk_model_1 = require("@gooddata/sdk-model");
var objRefMap_1 = require("../../../_staging/metadata/objRefMap");
var backendCapabilitiesSelectors_1 = require("../backendCapabilities/backendCapabilitiesSelectors");
var selectors_1 = require("../_infra/selectors");
var entitySelectors = insightsEntityAdapter_1.insightsAdapter.getSelectors(function (state) { return state.insights; });
/**
 * Selects all insights used on the dashboard.
 *
 * @remarks
 * Note: if you are aiming to lookup insights using an ObjRef, then you should instead use the map returned
 * by {@link selectInsightsMap}. If you are aiming to lookup a single insight by its ref, use {@link selectInsightByRef}.
 * Using these selectors is both faster and safer as they take ObjRef type into account and look up the insight
 * depending on the type of the ref.
 *
 * See {@link selectInsightsMap} or {@link selectInsightByRef} for a faster and safer ways to get
 * an insight by its ObjRef.
 * @public
 */
exports.selectInsights = entitySelectors.selectAll;
/**
 * Selects refs of all insights used on the dashboard.
 *
 * @alpha
 */
exports.selectInsightRefs = toolkit_1.createSelector(exports.selectInsights, function (insights) {
    return insights.map(sdk_model_1.insightRef);
});
/**
 * Selects all insights and returns them in a mapping of obj ref to the insight object.
 *
 * @alpha
 */
exports.selectInsightsMap = toolkit_1.createSelector(exports.selectInsights, backendCapabilitiesSelectors_1.selectBackendCapabilities, function (insights, capabilities) {
    return objRefMap_1.newInsightMap(insights, capabilities.hasTypeScopedIdentifiers);
});
/**
 * Selects insight used on a dashboard by its ref.
 *
 * @alpha
 */
exports.selectInsightByRef = selectors_1.createMemoizedSelector(function (ref) {
    return toolkit_1.createSelector(exports.selectInsightsMap, function (insights) {
        return ref && insights.get(ref);
    });
});
//# sourceMappingURL=insightsSelectors.js.map